(ns teamoesterreich.admin-mode.modal.message
  (:require ["react-virtualized" :as rv]
            [reagent.core :as r]
            [reagent-material-ui.components :as mui]
            [reagent-material-ui.icons.done :refer [done]]
            [reagent-material-ui.icons.keyboard-arrow-left  :refer [keyboard-arrow-left]]
            ))


(defn modal [!show message & [ok-message on-ok-fn]]

  [mui/modal
   {
    :aria-labelledby "simple-modal-title"
    :aria-describedby "simple-modal-description"
    :style {:display "flex"
            :marginRight "auto"
            :marginLeft "auto"
            :alignItems "center"
            :justifyContent "center"}
    :open (or @!show false)

    }
   [:div
    {
     :class "modal"
     :style {:width 600}}
    [:h4  message]

    [:br]
    [:br]
    [mui/button
     {:style {:float "right" }
      :variant "contained"
      :startIcon (r/as-element [done])
      :onClick (fn []
                 (when on-ok-fn (on-ok-fn))
                 (reset! !show false))
      }
     (or ok-message "OK")]]
   ]
  )


